module.exports = __webpack_public_path__ + "img/HYDROSPACE.79a1fb5.jpg";